<template>
  <v-stepper-content step="5">
    <v-card class="mx-1 mb-12">
      <v-card-title>{{
        $t("form.labels.orderSummary").toUpperCase()
      }}</v-card-title>
      <v-card-text>
        <template v-for="(participant, index) in participants">
          <div :key="index">
            <span class="subtitle-2">{{ $t("form.labels.name") }}:</span>
            {{ participant.firstname }} {{ participant.lastname }}
            <br />
            <span class="subtitle-2">{{ $t("form.fields.type") }}:</span>
            {{ $t(`form.memberTypes.${participant.type.toUpperCase()}`) }}
            <br />
            <span class="subtitle-2">
              {{ $tc("form.labels.registration", 2) }}:&nbsp;
            </span>
            <span
              v-for="(
                selectedPackage, pkgIndex
              ) in participanFilteredSelectedPackages(participant)"
              :key="selectedPackage.key"
              :set="
                (pricingTable = pricingTableForPackage(selectedPackage.key))
              "
            >
              <template v-if="pricingTable">
                {{ pkgIndex > 0 ? "," : "" }}

                {{ priceTitle(priceForKey(selectedPackage.key), $i18n.locale) }}
                <template
                  v-if="
                    additionalInfoForPrice(
                      selectedPackage,
                      pricingTable,
                      participant
                    ).info
                  "
                >
                  ({{
                    additionalInfoForPrice(
                      selectedPackage,
                      pricingTable,
                      participant
                    ).info
                  }})
                </template>
              </template>
            </span>

            <v-row class="mt-n1 mb-2">
              <v-col>
                <span class="title">{{ $t("form.labels.subtotal") }}:</span>
              </v-col>
              <v-col cols="2" align-self="end">
                <span class="title">{{ participantCost(participant) }} €</span>
              </v-col>
            </v-row>

            <v-divider />
          </div>
        </template>
        <v-row>
          <v-col>
            <span class="headline font-weight-bold"
              >{{ $t("form.labels.total") }}:</span
            >
          </v-col>
          <v-col cols="2" align-self="end">
            <span class="headline font-weight-bold">{{ cartSum }} €</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-layout>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="mr-4" @click="$emit('onContinue')">{{
        $t("form.btn.continue")
      }}</v-btn>
      <v-btn text @click="$emit('onBack')">{{ $t("form.btn.back") }}</v-btn>
    </v-layout>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "participants",
      "participantCost",
      "cartSum",
      "priceForKey",
      "priceTitle",
      "pricingTableForPackage",
      "additionalInfoForPrice",
      "participanFilteredSelectedPackages",
    ]),
  },
};
</script>

<style></style>
